<!-- @format -->

<ng-container *transloco="let t">
  <fudis-select
    [size]="'lg'"
    [placeholder]="t('PLAN_EDIT.SELECTION_MODAL.SEARCH_PLACEHOLDER')"
    [label]="t('PLAN_EDIT.SELECTION_MODAL.ANY_COURSE_UNIT_RULE.SEARCH_COURSE_UNITS_LABEL')"
    [control]="courseUnitSelectControl"
    [variant]="'autocompleteType'"
    [helpText]="t('PLAN_EDIT.SELECTION_MODAL.SEARCH_HELP_TEXT')"
    (selectionUpdate)="updateSelected.emit($event?.value)"
    (filterTextUpdate)="searchTextUpdateSubject.next($event)">
    <ng-template fudisSelectOptions>
      @if (searchResults | async; as options) {
        <fudis-select-option *ngFor="let option of options.homeUniversityCourseUnits" [data]="option" />
        @if (crossStudyFeaturesEnabled) {
          <fudis-select-group [label]="t('PLAN_EDIT.RIPA_SELECT_GROUP_LABEL')">
            <fudis-select-option *ngFor="let option of options.cooperationNetworkCourseUnits" [data]="option" />
          </fudis-select-group>
        }
      }
    </ng-template>
  </fudis-select>
</ng-container>
